import * as React from 'react';
import { Api } from '../../../typings/api';
import NativeApi from '../../../utils/nativeApi';
import Utils from '../../../utils';
import UserAgentUtils from '../../../utils/userAgent';
import DriveItemUtils from '../../../utils/driveItem';
import StatsUtils from '../../../utils/statistics';
import { StoreState } from '../../../reducers';
import { StyledShareButton } from './styles';
import { SharePanelActionKeys } from '../../Share/Panel/actions';
import { connect, Dispatch } from 'react-redux';
import UrlUtils from '../../../utils/url';
import { DriveItemListOrigin } from '../../DriveItemListPage/constants';
import Tooltip from '../../../components/Tooltip';
import { AppType } from '../../App/reducer';

const I18n = require('react-redux-i18n').I18n;

export interface ShareButtonProps {
	shareOrigin: ShareOrigin;
	galleryConfig: Api.Config;
	isBold?: boolean;
	dispatch: Dispatch<StoreState>;
	isNativeShare: boolean;
	sharedItems: Api.DriveItem[];
}

interface ShareButtonContainerProps {
	driveItems?: Api.DriveItem[];
}

export enum ShareOrigin {
	Detail = '@@ShareOrigin/detail',
	Theater = '@@ShareOrigin/theater',
	Favorites = '@@ShareOrigin/favorites',
}

export const ShareButton = (props: ShareButtonProps) => {

	const handleClick = (e: React.MouseEvent<HTMLDivElement>) => {
		const { sharedItems, isNativeShare, dispatch } = props;

		StatsUtils.trackShare(sharedItems);

		if (isNativeShare) {
			const title = getShareTitle();
			const url = getShareLink();
			NativeApi.shareApp(title, url);
		} else {
			dispatch(
				{
					type: SharePanelActionKeys.SET_SELECTION,
					selection: sharedItems,
				}
			);

			dispatch({ type: SharePanelActionKeys.REQUEST_OPEN });
		}
	};

	const getShareTitle = () => {
		const { sharedItems } = props;
		const firstItem = sharedItems[0];

		if (sharedItems.length > 1) {
			return I18n.t('messages.selection');
		}

		return DriveItemUtils.getLabel(firstItem);
	};

	const getShareLink = () => {
		const { sharedItems, galleryConfig, shareOrigin } = props;

		if (sharedItems.length > 1) {
			return `${UrlUtils.getUrlDriveItemListPage(galleryConfig, DriveItemListOrigin.Selection, sharedItems.map(driveItem => driveItem.id).join(), true)}`;
		}

		const firstItem = sharedItems[0];
		if (firstItem.type === Api.DriveItemType.Directory) {
			return `${UrlUtils.getUrlDriveItemListPage(galleryConfig, DriveItemListOrigin.Folder, firstItem.id.toString(), true)}`;
		}

		switch (shareOrigin) {
			case ShareOrigin.Detail:
				return `${UrlUtils.getUrlDriveItemDetailPage(galleryConfig, firstItem.id, undefined, true)}`;
			case ShareOrigin.Favorites:
				return `${UrlUtils.getUrlDriveItemListPage(galleryConfig, DriveItemListOrigin.Selection, sharedItems[0].id.toString(), true)}`;
			case ShareOrigin.Theater:
			default:
				return `${UrlUtils.getUrlTheater(galleryConfig, DriveItemListOrigin.Folder, firstItem.parent.toString(), firstItem.id, true)}`;
		}
	};

	const { isBold } = props;
	const iconName = isBold ? 'iconset_share-bold' : 'iconset_share';
	const tooltipId = Utils.generateId();

	return (
		<StyledShareButton onClick={handleClick} data-tip={!isBold} data-for={tooltipId}>
			{Utils.getSvgIcon(iconName)}
			{(UserAgentUtils.isDesktop() && !isBold) &&
				<Tooltip id={tooltipId} text={'messages.share'} />
			}
		</StyledShareButton>
	);
};

const mapStateToProps = (state: StoreState, props: ShareButtonContainerProps) => {
	const { galleryInfos, appInfos, authentication, driveList, routerParamsHistory } = state;
	const { driveItems } = props;
	const { needCredentials } = authentication.userInfos;
	const driveItemsStore = driveList.driveItems;
	const galleryConfig = galleryInfos.config;
	const galleryId = galleryConfig.applicationGallery;
	const type = appInfos.type || AppType.Single;
	const isNativeShare = UserAgentUtils.isMobileApp && !Utils.isSecure(type, needCredentials);

	// if Share shouldn't be native and the path is the gallery root, we send the gallery as the shared item
	const isGalleryRoot = Utils.isGalleryRoot(routerParamsHistory[routerParamsHistory.length - 1]);
	const sharedItems = !isNativeShare && isGalleryRoot ? [driveItemsStore[galleryId]] : driveItems;

	return { galleryConfig, isNativeShare, sharedItems};
};

export default connect(mapStateToProps)(ShareButton);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Share/ShareButton/index.tsx